/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FormChoice } from "./FormChoice";

/**
 * A field the builder can turn on for a section.
 */
export type FormFieldInfo = {
  field: string;
  label: string;
  kind: FormFieldInfo.kind;
  input: string;
  options?: Array<FormChoice> | null;
  min_value?: number | string | null;
  max_value?: number | string | null;
};

export namespace FormFieldInfo {
  export enum kind {
    BUILTIN = "builtin",
    CRM = "crm",
    NOTE = "note",
  }
}
